import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';

import {createForm, renderModalError} from '@utils/forms';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import {showModal} from '@utils/modal';
import {routes} from '@constants/routes';

import AdSpliceModel from '../form/AdSpliceModel';
import AdSpliceForm from '../form/AdSpliceForm';
import AdSpliceEditButtons from '../components/AdSpliceEditButtons';

export const AdSpliceEdit = ({
    match: {
        params: {id = null},
    },
}) => {
    const [pageTitle, setPageTitle] = React.useState('Ad splice config');

    let buttonProps = {name: 'adSplice.index'};

    if (!isUrlParamValid(id)) {
        showModal({
            isVisible: true,
            content: renderModalError('Ad Splice Config', routes.adSplice.index.path),
        });
    }

    const Form = React.useMemo(() => (
        createForm(
            AdSpliceModel,
            AdSpliceForm, {
                id: convertToInt(id),
                setPageTitle: setPageTitle,
                entityFetchPolicy: 'no-cache',
            }
        )
    ), []);

    return (
        <div>
            <HeaderRenderer
                buttons={AdSpliceEditButtons}
                buttonsProps={buttonProps}
                messagesBoxNames='adSpliceMessageError'
                pageTitle={pageTitle}
            />
            <Form/>
        </div>
    );
};
AdSpliceEdit.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }),
    }).isRequired,
};

AdSpliceEdit.displayName = 'AdSpliceEdit';

export default withRouter(AdSpliceEdit);
